import ProcessingType from "../../processing/models/ProcessingType";
import FieldStatisticAggregatorType from "../../statistic/models/StatisticAggregatorType";
import StatisticIndicatorType from "../../statistic/models/StatisticIndicatorType";
import Field from "../models/Field";
import FieldStatisticsSummary from "../models/FieldStatisticsSummary";

export const getFieldStatisticSummary = (field: Field, service: ProcessingType | null, indicator: StatisticIndicatorType | null,): FieldStatisticsSummary | undefined => {
    if (!field.statistics) {
        return;
    }

    if (!service) {
        return;
    }
    if (!indicator) {
        return;
    }

    const stat = field.statistics[service];

    if (!stat) {
        return;
    }

    const summary = stat[indicator];

    if (!summary) {
        return undefined
    }

    return summary;
}

export const getLastStatMainValue = (field: Field, service: ProcessingType | null, indicator: StatisticIndicatorType | null, key?: FieldStatisticAggregatorType): number => {
    if (!field.statistics) {
        return 0;
    }

    if (!service) {
        return 0;
    }
    if (!indicator) {
        return 0;
    }

    const stat = field.statistics[service];

    if (!stat) {
        return 0;
    }

    const summary = stat[indicator];

    if (!summary) {
        return 0
    }
    const lastValues = summary.last.values[key ?? "mean"] as string | number
    return lastValues ? parseFloat(lastValues as string) : 0;
}
export const getProducerRefFromFramerName = (farmerName: string): string => {
    return farmerName.replace(/\s/g, "")
}
